import { Modal } from '@calendly/ui/components/modal';
import { Sheet } from '@calendly/ui/components/sheet';
import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { Content } from './content';
import { Footer } from './footer';
import { Header } from './header';
import { TransferOwnershipPopup } from '../../transfer_ownership_modal';
const containerIsPhoneCss = "c1sisp59";
const containerCss = "c9ko7mp";
const Container = forwardRef((props, ref) => {
  const isPhone = useDeviceType('isPhone');
  return <Sheet ref={ref} {...props} className={classNames(containerCss, {
    [containerIsPhoneCss]: isPhone
  }, props.className)} />;
});
export const EditPermissionsModal = ({
  isOpen,
  onSubmit,
  onClose,
  scopeType
}) => <>
    <Modal isOpen={isOpen} onClose={onClose}>
      <Container>
        <Header />
        <Content scopeType={scopeType} />
        <Footer onSubmit={onSubmit} onClose={onClose} />
      </Container>
    </Modal>
    <TransferOwnershipPopup />
  </>;

require("./edit_permissions_modal.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./edit_permissions_modal.js");